import { insightsViewsClient } from '@app/helpers/requests/client';

/**
 * BCP-932: one call to an insights-views (BigQuery) view.
 *
 * `subsidiaryId` is omitted rather than sent empty: the service responds 400 to
 * a malformed uuid, and an absent value is the valid all-clients rollup.
 */
export const fetchInsightsView = ({ path, subsidiaryId }) =>
  insightsViewsClient.get(`/v1${path}`, {
    params: subsidiaryId ? { subsidiaryId } : undefined,
  });
